import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

/** One row in the static table of contents (snapshot from the playlist). */
interface PlaylistTocItem {
  title: string;
  videoId: string;
}

@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.css'],
})
export class ActivityComponent implements OnInit {
  /**
   * YouTube playlist ID from the playlist URL (`list=` query parameter).
   * https://www.youtube.com/playlist?list=PLUIMONaRf7Dwgfs1jR7jS5db6Z3VNxjZ2
   */
  readonly youtubePlaylistId = 'PLUIMONaRf7Dwgfs1jR7jS5db6Z3VNxjZ2';

  /**
   * Static snapshot of titles (update manually if the playlist changes).
   * Order was taken from the playlist RSS on 2026-04-13.
   */
  readonly playlistToc: PlaylistTocItem[] = [
    {
      videoId: 'YU9_bcmVXw4',
      title: '致歡迎辭: 聖方濟各大學 -- 盧鐵榮教授 (聖方濟各大學副校長)',
    },
    {
      videoId: 'nx87yWyTCjA',
      title: '跳舞及打功夫環節 -- johnny (SFU 機械人)',
    },
    {
      videoId: '_A6q77HW8i0',
      title:
        '政府在健康和長者領域的最新政策 -- 林正財醫生 (基督教靈實協會行政總裁)',
    },
    {
      videoId: '2smvqqXJmiU',
      title: '好好準備學老 -- 梁萬福醫生 (老年學會會長)',
    },
    {
      videoId: 'cAwh9oYSJXM',
      title:
        '人工智能在藝術與健康領域的應用 -- 梁以德教授 (任白慈善基金電子計算及信息科學院)',
    },
    {
      videoId: '2yybKpSfxNI',
      title:
        '粵劇表演藝術的數位轉型與曲譜學重塑 -- 馮穎匡博士 (彩鳳翔粵劇團特別顧問)',
    },
    {
      videoId: 'gdJdK2evNdA',
      title: '中華文化特色的認知障礙照顧 -- 戴樂群醫生 (香港認知障礙症協會)',
    },
    {
      videoId: 'crsSeSxl61k',
      title: '觀眾問答環節',
    },
  ];

  playlistEmbedUrl: SafeResourceUrl | null = null;

  constructor(private readonly sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.setPlaylistEmbedVideo(null);
  }

  /** Jump the embedded player to this video (stays within the playlist). */
  selectPlaylistVideo(item: PlaylistTocItem): void {
    this.setPlaylistEmbedVideo(item.videoId);
  }

  private setPlaylistEmbedVideo(videoId: string | null): void {
    if (!this.youtubePlaylistId) {
      this.playlistEmbedUrl = null;
      return;
    }
    const list = encodeURIComponent(this.youtubePlaylistId);
    const path = videoId
      ? `https://www.youtube.com/embed/${encodeURIComponent(
          videoId
        )}?list=${list}`
      : `https://www.youtube.com/embed/videoseries?list=${list}`;
    this.playlistEmbedUrl =
      this.sanitizer.bypassSecurityTrustResourceUrl(path);
  }
}
